export const COUNTRIES = [
  { id: 'iran', name: 'ایران' },
  { id: 'united states', name: 'ایالات متحده آمریکا' },
  { id: 'israel', name: 'اسرائیل' },
  { id: 'lebanon', name: 'لبنان' },
  { id: 'united kingdom', name: 'بریتانیا' },
  { id: 'china', name: 'چین' },
  { id: 'qatar', name: 'قطر' },
  { id: 'russia', name: 'روسیه' },
  { id: 'saudi arabia', name: 'عربستان سعودی' },
  { id: 'sweden', name: 'سوئد' },
  { id: 'greece', name: 'یونان' },
  { id: 'france', name: 'فرانسه' },
  { id: 'united arab emirates', name: 'امارات متحده عربی' },
  { id: 'turkey', name: 'ترکیه' },
  { id: 'azerbaijan', name: 'آذربایجان' },
  { id: 'south korea', name: 'کره جنوبی' },
  { id: 'syria', name: 'سوریه' },
  { id: 'japan', name: 'ژاپن' },
  { id: 'yemen', name: 'یمن' },
  { id: 'austria', name: 'اتریش' },
  { id: 'india', name: 'هند' },
  { id: 'czech republic', name: 'جمهوری چک' },
  { id: 'iraq', name: 'عراق' },
  { id: 'afghanistan', name: 'افغانستان' },
  { id: 'netherlands', name: 'هلند' },
  { id: 'germany', name: 'آلمان' },
  { id: 'switzerland', name: 'سوئیس' },
  { id: 'armenia', name: 'ارمنستان' },
  { id: 'oman', name: 'عمان' },
  { id: 'pakistan', name: 'پاکستان' },
  { id: 'turkmenistan', name: 'ترکمنستان' },
  { id: 'kuwait', name: 'کویت' },
];
